/* eslint-disable import/no-anonymous-default-export */
import headers from "client/utils/constants/headers";

const firstCohortDate = new Date("2021-12-15");

export default {
  firstCohortDate,
  headers,
};
